// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

// ==================import hook===================
import { useDispatch } from 'react-redux';

// ==================imports lib===================
import PropTypes from 'prop-types';

// ==================Actions===================
import { setFileClicked, setOpenModal } from '../../../../actions/file';

function ButtonValue({ val }) {
// ==================useHook===================
  const dispatch = useDispatch();

  // ==================Handler===================
  // function to display the modal
  function handleOpenModal(el) {
    dispatch(setFileClicked(el.target.textContent));
    dispatch(setOpenModal(true));
  }

  return (
    <button className="button--open" type="button" onClick={(el) => handleOpenModal(el)}>{val}</button>
  );
}

ButtonValue.propTypes = {
  val: PropTypes.string.isRequired,
};

export default ButtonValue;
